if (!customElements.get('halloween-countdown')) {
  customElements.define('halloween-countdown', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.end = Date.parse(this.dataset.end);
      this.fields = ['days', 'hours', 'minutes', 'seconds'].map(key => this.querySelector(`[data-${key}]`));
      this.caption = this.parentElement.querySelector('[data-countdown-caption]');
      this.tick = () => {
        const remaining = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
        const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
        this.fields.forEach((field, index) => { field.textContent = String(values[index]).padStart(2, '0'); });
        if (!remaining) { this.caption.textContent = 'Promocja Halloween Drop zakończona'; this.stop(); }
      };
      if (!Number.isFinite(this.end)) { this.caption.textContent = 'Sprawdź termin promocji'; return; }
      this.tick();
      if (this.end > Date.now()) this.interval = setInterval(this.tick, 1000);
    }
    stop() { clearInterval(this.interval); }
    disconnectedCallback() { this.stop(); }
  });
}
